import { type VisuallyHiddenTypographyClasses } from './VisuallyHiddenLabel.types'

export const visuallyHiddenTypographyClasses: VisuallyHiddenTypographyClasses = {
  root: 'VisuallyHiddenLabel',
}
